import { useEffect } from 'react';
import { SnapshotType } from 'types';
import { Route, useLocation, Routes, Navigate } from 'react-router-dom';
import { AppShell } from 'components';
import { useWidget } from '@telescope/cassini-hooks';
import { useColorMode } from '@telescope/cassini-ui';
import { ClosedPage, SpinTheWheelApp, AuthRoutes, ErrorPage, SlotMachineApp } from 'features';
import { Closed } from 'types';
import { Open } from 'types';
import { ROUTES } from 'utils';
import { useScroll } from 'hooks';

  // Returns the root level view based on the currently live snapshot type
const CurrentSnapshot = (props: { type: SnapshotType }) => {
  switch (props.type) {
    case SnapshotType.SLOT_MACHINE:
      return <SlotMachineApp />
    case SnapshotType.SPIN_THE_WHEEL:
      return <SpinTheWheelApp />
    case SnapshotType.CLOSED:
      return <ClosedPage />
      default:
      return null;
  }
};

export const AppRoutes = () => {
  const { data: colorModeSettings } = useWidget({ select: (data: Open | Closed) => data.widget.theme.settings.colorMode  });
  const { data } = useWidget({ select: (data: Open | Closed) => data.snapshot });
  const snapshot = data!;

  const { colorMode, toggleColorMode } = useColorMode();

  // Update colorMode when app settings changes
  useEffect(() => {
    if (colorModeSettings !== colorMode) {
      toggleColorMode();
    }
  }, [colorModeSettings, colorMode, toggleColorMode]);

  const { scrollToTop } = useScroll();

  const location = useLocation();
  const state = location.state as {
    backgroundLocation?: Location;
  };

  useEffect(() => {
    scrollToTop();
  }, [location.pathname])

  const authEnabledRoutes = [
    SnapshotType.SLOT_MACHINE,
    SnapshotType.SPIN_THE_WHEEL
  ] as string[];

  return (
    <>
      <Routes location={state?.backgroundLocation || location}>
        <Route path="/" element={<AppShell />}>
          <Route index={true} element={
            <CurrentSnapshot type={snapshot.type} />
          }/>
          <Route path={`${ROUTES.ERROR}/:errorType`} element={<ErrorPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
      <AuthRoutes isEnabled={authEnabledRoutes.includes(snapshot.type)}/>
    </>
  )
}